//SignIn_ArcGIS.ts =================================================
// Application needs to be registered with your Enterprise Portal or AGOL.
// In Portal -> My Content -> Add Item -> An Application -> Web Mapping -> Fill out the form
// In Portal -> My Content -> Apps Filter -> Your App -> Settings -> Register/RegisterInfo -> BrowserType -> App ID
// Use the AppID to set up the link from this app to the registered app
// Make sure the proper call backs are set up in the Portal/AGOL application settings page

import "./Prototypes";

import * as Settings from "../Settings";
import * as Util from "./Util";

export let signedIn: boolean = false;
export let email: string = "";
export let userName: string = "";
export let accessLevel: number = 0;

let oAuthInfo: __esri.OAuthInfo;
let callback: iCallbacks;

interface iCallbacks {
   success(): void;
   fail(): void;
}

//Sign in.
export function signIn() {
   import("@arcgis/core/identity/IdentityManager").then(({ default: esriId }) => {
      Util.logMsg("ArcGIS Auth2 - Logging in.");

      //Open the sign-in popup window. The callback from this popup will reload the website and authenticate.
      esriId.getCredential(oAuthInfo.portalUrl + "/sharing");
   });
}

//Sign out.
export function signOut() {
   import("@arcgis/core/identity/IdentityManager").then(({ default: esriId }) => {
      Util.logMsg("ArcGIS Auth2 - Logging out.");
      esriId.destroyCredentials();
      signedIn = false;
      accessLevel = 0;
      window.location.reload();
   });
}

//Initialize.
export function authenticate(callbacks: iCallbacks) {
   import("@arcgis/core/identity/IdentityManager").then(({ default: esriId }) => {
      import("@arcgis/core/identity/OAuthInfo").then(({ default: OAuthInfo }) => {
         import("@arcgis/core/portal/Portal").then(({ default: Portal }) => {

            callback = callbacks;
            Util.logMsg("ArcGIS Auth2: Creating OAuthInfo with AppID: " + Settings.arcgisAuth2_AppID);

            //Register with Portal to get SSO option.
            oAuthInfo = new OAuthInfo({ appId: Settings.arcgisAuth2_AppID });

            if (Settings.arcgisAuth2_PortalURL) {
               Util.logMsg("Portal URL: " + Settings.arcgisAuth2_PortalURL);
               oAuthInfo.portalUrl = Settings.arcgisAuth2_PortalURL; //Set to onsite portal instead of arcgis online.
            }
            esriId.registerOAuthInfos([oAuthInfo]);

            //check if user is logged in already, else go to the login screen.
            esriId.checkSignInStatus(oAuthInfo.portalUrl + "/sharing").then((credential) => {
               Util.logMsg("ArcGIS Sign In Successful - Credential: " + credential.userId, credential);

               //Get a portal.
               const portal = new Portal({ authMode: "immediate", url: oAuthInfo.portalUrl });

            //Get an access token.==================================
            //Util.errMsg("Getting token");
            //esriId.generateToken
            //Example:
            //https://github.com/vcoelho/ArcGISSamples/blob/master/identityManagerBase.html
            //======================================================

               portal.load().then(() => {
                  Util.logMsg("portal.user", portal.user);

                  if (portal.user) {
                     signedIn = true;
                     userName = portal.user.fullName;
                     email = portal.user.email;
                     accessLevel = 1; //Default for at least signing in.

                     //Set access level to the starting numeric portion of the group name.
                     portal.user.fetchGroups().then(function (fetchItemResult) {
                        Util.logMsg("user's groups: ", fetchItemResult);

                        for (const portalGroup of fetchItemResult) {
                           Util.logMsg("Member of group: " + portalGroup.title);
                           if (portalGroup.title.toLowerCase().includes("access level")) {
                              Util.logMsg("Found access level group: " + portalGroup.title);
                              const al: number = Util.parseInteger(portalGroup.title);
                              Util.logMsg("al: " + al);
                              if (al > accessLevel) {
                                 accessLevel = al;
                                 Util.logMsg("Setting accessLevel to: " + accessLevel);
                              }
                           }
                        }
                        callback.success();
                     });
                  }

               }).catch((error: Error) => {
                  Util.errMsg("Portal failed to load: " + oAuthInfo.portalUrl);
               });

            }).catch((error: Error) => {
               Util.logMsg("User is not signed-in", error);
               signedIn = false;
               accessLevel = 0;
               callback.fail();
            });

         }); //end import.
      }); //end import.
   }); //end import.
}
